import React from 'react';
import { useIntl } from 'react-intl';

import config from '../../../config';
import SortByPlain from './SortByPlain';
import SortByPopup from './SortByPopup';

const SortBy = ({ sort = null, showAsPopup = false, isConflictingFilterActive, ...rest }) => {
  const intl = useIntl();
  const { relevanceKey, queryParamName } = config.custom.sortConfig;

  const options = config.custom.sortConfig.options.map((option) => {
    const isRelevance = option.key === relevanceKey;
    return {
      ...option,
      disabled:
        (isRelevance && !isConflictingFilterActive) || (!isRelevance && isConflictingFilterActive),
    };
  });
  const defaultValue = 'pub_verified,-price';
  const componentProps = {
    urlParam: queryParamName,
    label: intl.formatMessage({ id: 'SortBy.heading' }),
    options,
    initialValue: isConflictingFilterActive ? relevanceKey : sort || defaultValue,
    ...rest,
  };
  return showAsPopup ? <SortByPopup {...componentProps} /> : <SortByPlain {...componentProps} />;
};

export default SortBy;
